var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChild(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 3C18 3 19.8886 7.62046 19.7537 11.9962L19.7086 13.4568C19.6171 16.425 17.6919 19.1532 14.7759 19.7148C12.8016 20.0951 11.1989 20.0951 9.22465 19.7148C6.30862 19.1532 4.38349 16.425 4.29194 13.4568L4.2469 11.9962C4.11194 7.62046 6.00056 3 12.0003 3ZM12.0003 3C12.0003 8.5 9.50028 10.5343 4.50028 10M12.0003 3C12.0003 8.5 14.5003 10.5343 19.5003 10M15.0003 13H15.0103M9.00028 13H9.01028M10.5003 16C11.2503 17 12.7503 17 13.5003 16M19.5003 10.0265C24.0852 9.4922 24.0877 15.4889 19.9665 15.4982M4.50028 10.0259C-0.0846751 9.49156 -0.0871449 15.4883 4.03411 15.4975",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChild);
export default __webpack_public_path__ + "static/media/icon-child.f962d6eab8ece71a1e44f4dc26be09bd.svg";
export { ForwardRef as ReactComponent };